export default {
  search_placeholder: "搜尋目的地",
  places_around: "您目前所在位置周圍",
  reward_type: "報酬類型",
  pr_method: "公關方式",
  sns_specify: "指定社群媒體",
  age_specify: "網紅的希望年齡範圍",
};
